import { render, staticRenderFns } from "./BirthdayGift.vue?vue&type=template&id=456ddd06&"
import script from "./BirthdayGift.vue?vue&type=script&lang=js&"
export * from "./BirthdayGift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports